<template>
	<div class="k-resource-view" style="position: relative">
		<div style="position: absolute; left: 12px; top: 16px">
			<k-icon class="k-resource-view-resource-icon" style="font-size: 28px" :style="resource_icon_style" :color="resource_color">fas fa-{{ resource_icon }}</k-icon>
		</div>

		<!--------------------------- EDITOR -------------------------------->
		<div v-if="editing_resource && current_resource">
			<div class="k-case-ie-line">
				<div class="k-case-ie-line-label"></div>
				<h3 v-if="is_new_resource">
					<k-icon color="black" class="mr-2">fas fa-circle-plus</k-icon>Add Resource
				</h3>
				<h3 v-if="!is_new_resource">
					<k-icon color="black" class="mr-2">fas fa-edit</k-icon>Edit Resource
				</h3>
			</div>

			<div class="k-case-ie-line">
				<div class="k-case-ie-line-label" @click="generate_random_resource_id">*Resource ID:</div>
				<k-text-field background-color="#fff" outlined dense hide-details v-model="resource_for_editing.external_resource_id" placeholder="" clearable></k-text-field>
			</div>

			<div class="k-case-ie-line">
				<div class="k-case-ie-line-label">Title:</div>
				<k-text-field background-color="#fff" outlined dense hide-details v-model="resource_for_editing.resource_title" placeholder="" clearable></k-text-field>
			</div>

			<div class="k-case-ie-line">
				<div class="k-case-ie-line-label">URL:</div>
				<k-text-field background-color="#fff" outlined dense hide-details v-model="resource_for_editing.url" placeholder="" clearable></k-text-field>
			</div>

			<div class="k-case-ie-line">
				<div class="k-case-ie-line-label">Description:</div>
				<k-textarea class="k-resource-editor-description-textarea" background-color="#fff" outlined dense hide-details v-model="resource_for_editing.description" placeholder="" rows="2" auto-grow clearable></k-textarea>
			</div>

			<div class="k-case-ie-line">
				<div class="k-case-ie-line-label"><nobr>Full Content:</nobr></div>
				<k-textarea class="k-resource-editor-description-textarea" background-color="#fff" outlined dense hide-details v-model="resource_for_editing.full_content" placeholder="" rows="2" auto-grow clearable></k-textarea>
			</div>

			<div class="k-case-ie-line">
				<div class="k-case-ie-line-label">Keywords:</div>
				<k-textarea background-color="#fff" outlined dense hide-details v-model="resource_for_editing.text" placeholder="" rows="2" auto-grow clearable></k-textarea>
			</div>

			<div class="k-case-ie-line">
				<div class="k-case-ie-line-label">Education&nbsp; level:</div>
				<div class="d-flex" style="width: 200px">
					<div style="flex: 1 1 50%">
						<k-select background-color="#fff" v-model="grade_low" :items="grades" label="Low" outlined dense hide-details :menu-props="{ top: true, dense: true }"></k-select>
					</div>
					<div class="ml-1" style="flex: 1 1 50%">
						<k-select background-color="#fff" v-model="grade_high" :items="grades" label="High" outlined dense hide-details :menu-props="{ top: true }"></k-select>
					</div>
				</div>
				<k-spacer />
				<k-btn small color="red darken-3" dark class="mr-6" @click="edit_resource_remove">
					<k-icon small class="mr-2">fas fa-trash-alt</k-icon>Remove
				</k-btn>
				<k-btn small color="secondary" class="mr-2" @click="edit_resource_cancel">
					<k-icon small class="mr-2">fas fa-xmark</k-icon>Cancel
				</k-btn>
				<k-btn small :color="!edited_resource_changed ? '#ccc' : resource_color" dark @click="edit_resource_save">
					<k-icon small class="mr-2">fas fa-save</k-icon>Save {{ is_new_resource ? 'Resource' : 'Changes' }}
				</k-btn>
			</div>
		</div>

		<!--------------------------- VIEWER -------------------------------->
		<div v-if="!editing_resource && current_resource" class="k-resource-alignment-maker-resource-fields">
			<div class="k-case-ie-line" style="position: relative">
				<div class="k-case-ie-line-value" style="font-size: 13px; margin-left: 36px">
					<b style="color: #444">Resource ID:</b>
					<span style="margin-left: 12px" v-html="current_resource.external_resource_id"></span>
					<k-btn small icon color="#444" style="margin: -4px 0 0 4px" accessible-label="Edit resource" @click="edit_resource_start">
						<k-icon small>fas fa-edit</k-icon>
					</k-btn>
				</div>
				<k-spacer />
				<div class="d-flex align-center" style="margin-top: -4px">
					<k-btn small fab :color="resource_color" outlined class="" accessible-label="Show previous resource" @click="$emit('go_to_resource', 'prev')" :disabled="current_resource_index < 1">
						<k-icon small>fas fa-arrow-left</k-icon>
					</k-btn>
					<k-btn small class="ml-1" fab :color="resource_color" outlined accessible-label="Show next resource" @click="$emit('go_to_resource', 'next')" :disabled="current_resource_index >= table_filtered_resources.length - 1">
						<k-icon small>fas fa-arrow-right</k-icon>
					</k-btn>
				</div>
			</div>

			<div class="k-case-ie-line" v-show="current_resource.url">
				<div class="k-case-ie-line-label d-flex align-center">
					<!-- <k-checkbox v-visible="false" class="shrink mt-0 pt-0 float-left" hide-details></k-checkbox> -->
					<div>URL:</div>
				</div>
				<div class="k-case-ie-line-value" style="white-space: nowrap; overflow: hidden">
					<a :href="current_resource.url" target="_blank" v-html="current_resource.url"></a>
				</div>
			</div>

			<div class="k-case-ie-line">
				<div class="k-case-ie-line-label d-flex align-center">
					<k-checkbox class="shrink mt-0 pt-0 float-left" hide-details :disabled="comp_factor_weights.item == 0" v-model="comp_factors.title" @change="comp_factors_changed"></k-checkbox>
					<div>Title:</div>
				</div>
				<div class="k-case-ie-line-value" v-html="current_resource.resource_title"></div>
			</div>

			<div class="k-case-ie-line" v-show="current_resource.description">
				<div class="k-case-ie-line-label d-flex align-center">
					<k-checkbox class="shrink mt-0 pt-0 float-left" hide-details :disabled="comp_factor_weights.item == 0" v-model="comp_factors.description" @change="comp_factors_changed"></k-checkbox>
					<div>
						Description:
						<div v-show="description_expandable" class="text-center">
							<k-btn x-small text class="k-tight-btn" color="primary" @click="description_expanded = !description_expanded">{{ description_expanded ? 'Contract' : 'Expand' }}</k-btn>
						</div>
					</div>
				</div>
				<div class="k-case-ie-line-value k-resource-view-description" v-show="current_resource.description" style="max-height: 72px; overflow: auto; border: 1px solid #999; padding-left: 8px; padding-right: 8px; padding-bottom: 6px; border-radius: 4px; width: 100%;" :style="description_expanded ? 'max-height:360px' : ''" v-html="current_resource.description"></div>
			</div>

			<div class="k-case-ie-line" v-show="current_resource.full_content">
				<div class="k-case-ie-line-label d-flex align-center">
					<k-checkbox class="shrink mt-0 pt-0 float-left" hide-details :disabled="comp_factor_weights.item == 0" v-model="comp_factors.full_content" @change="comp_factors_changed"></k-checkbox>
					<div>
						<nobr>Full Content:</nobr>
						<div v-show="full_content_expandable" class="text-center">
							<k-btn x-small text class="k-tight-btn" color="primary" @click="full_content_expanded = !full_content_expanded">{{ full_content_expanded ? 'Contract' : 'Expand' }}</k-btn>
						</div>
					</div>
				</div>
				<div class="k-case-ie-line-value k-resource-view-full_content" v-show="current_resource.full_content" style="max-height: 72px; overflow: auto; border: 1px solid #999; padding-left: 8px; padding-right: 8px; padding-bottom: 6px; border-radius: 4px; width: 100%;" :style="full_content_expanded ? 'max-height:360px' : ''" v-html="current_resource.full_content"></div>
			</div>

			<div class="k-case-ie-line" v-show="current_resource.text">
				<div class="k-case-ie-line-label d-flex align-center">
					<k-checkbox class="shrink mt-0 pt-0 float-left" hide-details :disabled="comp_factor_weights.item == 0" v-model="comp_factors.text" @change="comp_factors_changed"></k-checkbox>
					<div>Keywords:</div>
				</div>
				<div class="k-case-ie-line-value" v-html="current_resource.text"></div>
			</div>

			<div class="k-case-ie-line">
				<div class="k-case-ie-line-label d-flex align-center">
					<k-checkbox class="shrink mt-0 pt-0 float-left" hide-details :disabled="comp_factor_weights.item == 0" v-model="comp_factors.search_terms" @change="comp_factors_changed"></k-checkbox>
					<div>Search Terms:</div>
				</div>
				<!-- We always show the search_terms editor -->
				<k-textarea background-color="#fff" outlined dense hide-details v-model="current_resource_search_terms_wrapper" placeholder="" rows="1" auto-grow clearable @keydown="current_resource_search_terms_keydown"></k-textarea>
			</div>

			<div class="k-case-ie-line" v-show="grade_low">
				<div class="k-case-ie-line-label d-flex align-center">
					<k-checkbox class="shrink mt-0 pt-0 float-left" hide-details v-model="comp_factors.education_level" @change="comp_factors_changed"></k-checkbox>
					<div>Ed. level:</div>
				</div>
				<div class="k-case-ie-line-value">
					{{ grade_low.text }}<span v-if="grade_low != grade_high">–{{ grade_high.text }}</span>
				</div>
			</div>

			<!-- Current alignments to base framework (if a base framework is specified) -->
			<div v-if="!suggestion_computing && base_framework_identifier" class="mt-3 pt-2">
				<div v-if="no_alignments_to_base_framework" class="mt-2">
					<b>NO ALIGNMENTS TO BASE FRAMEWORK</b> ({{ base_framework_record.json.CFDocument.title }})
				</div>
				<div v-else>
					<div v-for="framework in alignments_to_show" v-if="framework.cfdocument.identifier == base_framework_identifier" :key="framework.cfdocument.identifier">
						<div class="d-flex mt-1">
							<div style="margin: -5px 6px 0 0" v-visible="framework.framework_record != tba_framework_record">
								<k-icon style="font-size: 20px" color="primary" @click="set_base_framework(framework.framework_record)">{{ framework.cfdocument.identifier == base_framework_identifier ? 'far fa-circle-dot' : 'far fa-circle' }}</k-icon>
							</div>
							<b style="font-size: 14px; line-height: 18px" class="mr-2">BASE FRAMEWORK ALIGNMENTS:</b>
							<b class="grey--text text--darken-2" style="font-size: 14px; line-height: 18px">{{ framework.cfdocument.title }}</b>
							<k-spacer />
							<div class="ml-3" style="font-size: 14px">
								<nobr>{{ framework.alignments.length }} {{ U.ps('Alignment', framework.alignments.length) }}</nobr>
							</div>
							<k-btn x-small color="#777" text @click="item_alignments_wrap = !item_alignments_wrap">
								<k-icon small style="transform: rotate(90deg)">fas fa-turn-down</k-icon>
							</k-btn>
						</div>
						<div v-for="ao in framework.alignments" :key="ao.key" class="k-resource-view-current-alignment" :class="item_alignments_wrap ? '' : 'k-resource-view-current-alignment-nowrap'">
							<k-btn x-small icon dark style="width: 24px; height: 24px; margin-top: -4px" class="mr-1 elevation-0" :color="resource_color" @click="show_alignment(ao.alignment)">
								<k-icon x-small style="transform: rotate(45deg)">fas fa-down-left-and-up-right-to-center</k-icon>
							</k-btn>
							<b v-if="ao.hcs" class="mr-2 k-resource-view-item-link" style="white-space: nowrap" v-html="ao.hcs" @click="show_alignment(ao.alignment)"></b>
							<div class="k-resource-view-item-link" v-html="ao.statement" @click="show_alignment(ao.alignment)"></div>
						</div>
					</div>
				</div>
			</div>

			<div class="k-case-ie-line"></div>

			<!-- if resource has been marked as a nomatch, show that here -->
			<div class="mt-4 py-2 text-center red lighten-4"
				v-if="nomatch_assoc"
				:style="`border-top:1px solid ${resource_color}`"
			>
				This Resource is marked as having <b>no alignment</b> to the to-be-aligned framework
				<k-btn small color="primary" class="ml-3"
					@click="cancel_no_match"
				><k-icon small class="mr-2">fas fa-xmark</k-icon>Cancel</k-btn>
			</div>


			<!-- candidate suggestions -->
			<div class="mt-4 pt-0"
				v-if="tba_framework_identifier"
				:style="`border-top:1px solid ${resource_color}`"
			>
				<div class="d-flex align-center mt-2">
					<nobr><b>Alignment Suggestions:</b></nobr>

					<div v-if="suggestion_computing" class="k-suggestion-computing-flasher ml-2" style="border-radius: 4px; padding: 1px 5px; margin-top: 3px; font-size: 12px; font-weight: bold">
						COMPUTING…
					</div>
					<div v-if="suggestions_updated_showing" class="green darken-3 white--text ml-2" style="border-radius: 4px; padding: 1px 5px; margin-top: 3px; font-size: 12px; font-weight: bold">
						UPDATED
					</div>

					<k-spacer />

					<div class="d-flex align-center px-2" style="font-size: 14px; border-radius: 4px; background-color: #eee">
						<div class="text-right mr-2">Resource</div>
						<b style="flex: 0 0 30px; width: 30px" class="d-block text-center">{{ comp_factor_weights.item == 1000 ? '100' : (comp_factor_weights.item / 10).toFixed(1) }}%</b>
						<div style="width: 160px" class="ml-2 mr-1">
							<k-slider v-model="item_assoc_weight_pct" hide-details dense min="0" max="6" step="1" ticks="always" tick-size="5"></k-slider>
						</div>
						<b style="flex: 0 0 30px; width: 30px" class="d-block text-center">{{ comp_factor_weights.assocs == 1000 ? '100' : (comp_factor_weights.assocs / 10).toFixed(1) }}%</b>
						<div class="text-left ml-3"><nobr>Cross-alignments</nobr></div>
					</div>

					<!-- btn to start aligning (you can click this instead of clicking a suggestion, or if you don't have any suggestions) -->
					<k-btn x-small fab color="primary" class="ml-3 elevation-0" @click="start_alignment">
						<k-icon small>fas fa-tree</k-icon>
					</k-btn>

					<k-btn x-small color="#777" text style="margin-top: 3px" @click="item_alignments_wrap = !item_alignments_wrap">
						<k-icon small style="transform: rotate(90deg)">fas fa-turn-down</k-icon>
					</k-btn>
				</div>

				<div class="d-flex k-resource-alignment-normalize-wrapper">
					<k-checkbox class="mt-0 pt-0" v-model="normalize_match_score_bars" hide-details color="pink darken-3" off-icon="far fa-circle" on-icon="fas fa-check-circle">
						<template v-slot:label>
							<div style="font-size: 14px" :class="normalize_match_score_bars ? 'pink--text text--darken-3' : ''">
								“Normalize” suggestion bars
							</div>
						</template>
					</k-checkbox>
					<k-spacer />
				</div>

				<!-- show branch we're limiting too, if one has been clicked -->
				<div v-if="last_clicked_tba_limiter" class="d-flex align-center mt-2 px-2 py-1 amber darken-2 xwhite--text" style="border-radius: 4px">
					<k-btn x-small icon color="black" class="mr-0" @click="cancel_last_clicked_tba_limiter">
						<k-icon>fas fa-circle-xmark</k-icon>
					</k-btn>
					<k-btn v-if="last_clicked_tba_limiter.fullStatement" x-small icon color="black" class="ml-1" @click="tba_limiter_move_up">
						<k-icon>fas fa-caret-up</k-icon>
					</k-btn>
					<div v-if="last_clicked_tba_limiter.fullStatement" class="ml-2">
						<b>Limiting to:</b> {{ U.generate_cfassociation_node_uri_title(last_clicked_tba_limiter, 50) }}
					</div>
					<div v-else class="ml-2">
						<b>Showing children of Framework Document</b>
					</div>
					<k-spacer />
					<k-btn-toggle dense active-class="k-toggle-btn-active-class" class="k-toggle-btn" v-model="children_or_alignable" mandatory>
						<k-tooltip left>
							<template v-slot:activator="{ on }">
								<k-btn v-on="on" small light :value="'children'" accessible-label="Show children plus top alignable items" @click.stop="">
									<k-icon style="font-size: 18px">fas fa-children</k-icon>
								</k-btn>
							</template>
							<div class="text-center">
								Show children of selected branch,<br />plus top alignable item under each child
							</div>
						</k-tooltip>
						<k-tooltip bottom nudge-left="60">
							<template v-slot:activator="{ on }">
								<k-btn v-on="on" small light :value="'alignable'" accessible-label="Show all alignable items under the selected branch" @click.stop="">
									<k-icon style="font-size: 22px">fas fa-arrows-left-right</k-icon>
								</k-btn>
							</template>
							<div class="text-center">Show all alignable items<br />under the selected branch</div>
						</k-tooltip>
					</k-btn-toggle>
				</div>

				<div class="my-2 grey--text text--darken-2" style="font-size: 14px; line-height: 18px; margin-top: 4px; font-weight: bold" v-html="tba_framework_record_descriptor"></div>

				<div v-if="!comp_factors_available" class="mt-2 pink--text text--darken-3 text-center" style="font-size: 14px; line-height: 18px">
					<i><b>You have not selected any factors for making suggestions.</b></i>
				</div>

				<div v-if="comp_factors_available && !suggestion_computing">
					<div v-if="base_item_for_alignment" class="mb-0 pink--text text--darken-3">
						<div>
							Limiting to items closest to item from Base Framework:
							<k-btn class="ml-2" x-small color="pink darken-3" dark @click="base_item_for_alignment = null; make_suggestions();">Cancel</k-btn>
						</div>
						<div class="d-flex mt-1 ml-8 align-start" style="font-size: 14px; line-height: 18px">
							<b>{{ base_item_for_alignment.ao.hcs }}</b>
							<div class="ml-2" v-html="base_item_for_alignment.ao.statement"></div>
						</div>
					</div>
					<div v-for="(candidate, i) in current_resource.candidates" v-if="candidate.currently_aligned || i < current_resource.candidates_showing" class="k-resource-view-current-alignment k-resource-view-candidate" :class="candidate_outer_class(candidate)">
						<k-checkbox class="shrink pt-0 float-left" color="green darken-3" style="margin-top: -3px" hide-details 
							v-show="candidate.is_alignable" 
							v-model="candidate.currently_aligned" 
							:disabled="!!nomatch_assoc"
							@change="candidate_alignment_changed(candidate)"
						></k-checkbox>
						<div class="k-resource-view-candidate-bar-outer mr-2">
							<k-tooltip bottom>
								<template v-slot:activator="{ on }">
									<div v-on="on" class="d-flex">
										<div v-show="candidate.is_alignable" style="font-size: 13px; margin: -1px 6px 0 0; width: 24px; text-align: right">
											{{ candidate.simscore }}
										</div>
										<div v-if="normalize_match_score_bars" class="k-resource-view-candidate-bar">
											<k-progress-linear v-model="candidate.simscore_pct_norm" :color="candidate_color(candidate)" :height="candidate.is_alignable ? 16 : 8"></k-progress-linear>
										</div>
										<div v-else class="k-resource-view-candidate-bar">
											<k-progress-linear v-model="candidate.simscore_pct" :color="candidate_color(candidate)" :height="candidate.is_alignable ? 16 : 8"></k-progress-linear>
										</div>
									</div>
								</template>
								<div class="k-resource-factor-tooltip-outer" v-html="candidate.factor_string"></div>
							</k-tooltip>
						</div>
						<b v-if="candidate.cfitem.humanCodingScheme" class="k-resource-view-item-link mr-2" style="white-space: nowrap" v-html="candidate.cfitem.humanCodingScheme" @click="candidate_clicked(candidate)"></b>
						<div class="k-resource-view-item-link" v-html="candidate.cfitem.fullStatement" @click="candidate_clicked(candidate)"></div>
					</div>
					<div class="d-flex mt-2 ml-7">
						<k-btn v-if="current_resource.candidates.length > current_resource.candidates_showing" small text :color="resource_color" @click="set_candidates_showing(current_resource, 5)">
							<k-icon small class="mr-2">fas fa-plus</k-icon>More Suggestions
						</k-btn>
						<k-spacer/>
						<k-btn small color="primary" class="k-tight-btn" outlined
							v-if="tba_framework_identifier && !nomatch_assoc && is_case_resource_set"
							:color="resource_color"
							@click="mark_as_no_match"
						><k-icon small class="mr-1">fas fa-ban</k-icon>Mark as “Not Aligned”</k-btn>
					</div>
				</div>
			</div>

			<!-- Current alignments; if we're using a base framework, we don't show the base framework here, because we show it above -->
			<div v-if="!suggestion_computing" class="mt-3 pt-2" :style="`border-top:2px solid ${resource_color}`">
				<div class="d-flex align-center">
					<b style="color: #444">{{ base_framework_identifier ? 'Alignments to other frameworks' : 'Current Alignments' }}:</b>
					<k-spacer />
					<k-btn x-small color="#777" text @click="item_alignments_wrap = !item_alignments_wrap">
						<k-icon small style="transform: rotate(90deg)">fas fa-turn-down</k-icon>
					</k-btn>
				</div>
				<div v-for="framework in alignments_to_show" v-if="!base_framework_identifier || framework.cfdocument.identifier != base_framework_identifier" :key="framework.cfdocument.identifier" class="mt-2 pt-1 ml-4" :style="`border-top:1px solid #aaa`">
					<div class="d-flex mt-1">
						<div style="margin: -5px 6px 0 0" v-visible="framework.framework_record != tba_framework_record">
							<k-icon style="font-size: 20px" color="primary" @click="set_base_framework(framework.framework_record)">{{ framework.cfdocument.identifier == base_framework_identifier ? 'far fa-circle-dot' : 'far fa-circle' }}</k-icon>
						</div>
						<b v-if="framework.cfdocument.identifier == base_framework_identifier" style="font-size: 14px; line-height: 18px" class="mr-2">BASE FRAMEWORK:</b>
						<b class="grey--text text--darken-2" style="font-size: 14px; line-height: 18px">{{ framework.cfdocument.title }}</b>
						<k-spacer />
						<div class="ml-3" style="font-size: 14px">
							<nobr>{{ framework.alignments.length }} {{ U.ps('Alignment', framework.alignments.length) }}</nobr>
						</div>
					</div>
					<div v-if="!base_framework_identifier || framework.cfdocument.identifier == base_framework_identifier">
						<div v-for="ao in framework.alignments" :key="ao.key" class="k-resource-view-current-alignment" :class="item_alignments_wrap ? '' : 'k-resource-view-current-alignment-nowrap'">
							<k-btn x-small icon dark style="width: 24px; height: 24px; margin-top: -4px" class="mr-1 elevation-0" :color="resource_color" @click="show_alignment(ao.alignment)">
								<k-icon x-small style="transform: rotate(45deg)">fas fa-down-left-and-up-right-to-center</k-icon>
							</k-btn>
							<b v-if="ao.hcs" class="mr-2 k-resource-view-item-link" style="white-space: nowrap" v-html="ao.hcs" @click="show_alignment(ao.alignment)"></b>
							<div class="k-resource-view-item-link" v-html="ao.statement" @click="show_alignment(ao.alignment)"></div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
// import ResourceAlignmentMixin from './ResourceAlignmentMixin'

export default {
	components: {},
	// mixins: [ResourceAlignmentMixin],
	props: {
		set_component: { required: true },
		resource_set: { type: Object, required: true },
		current_resource: { required: true },
		table_filtered_resources: { required: true },
		batch_alignments_to_create: { required: true },
		satchel_embed_width: { required: true }
		// nreq: { type: String, required: false, default() { return ''} },
	},
	data() {
		return {
			resource_for_editing: null,
			current_resource_search_terms: '',

			mode: '',
			lowest_ancestor: '',
			resource_icon: 'cube',
			resource_icon_rotation: 0,

			no_alignments_to_base_framework: false,

			save_current_resource_search_terms_debounced: null,
			prevent_current_resource_search_terms_debounce: false,

			candidates_showing_on_right: [],

			last_clicked_tba_limiter: null
		}
	},
	computed: {
		...mapState(['framework_records', 'association_type_labels', 'grades', 'user_info']),
		...mapGetters([]),
		resource_set_id() {
			return this.resource_set.resource_set_id
		},
		is_case_resource_set() {
			return this.set_component.is_case_resource_set
		},
		can_edit_alignments() {
			// for now we'll assume that if you're here you can edit alignments
			return true
		},
		resource_id() {
			return this.current_resource?.resource_id
		},
		base_item_for_alignment: {
			get() {
				return this.$store.state.base_item_for_alignment[this.resource_id]
			},
			set(val) {
				this.$store.commit('set', ['base_item_for_alignment', this.resource_id, val])
			}
		},
		is_new_resource() {
			return this.resource_id == 1
		},
		current_resource_index() {
			if (!this.set_component.resources_for_alignment) return null
			return this.table_filtered_resources.findIndex(x => x.resource_id == this.resource_id)
		},
		resource_color() {
			if (this.resource_for_editing) return this.resource_for_editing?.random_color()
			return this.current_resource?.random_color()
		},
		resource_icon_style() {
			if (this.resource_icon_rotation == 0) return ''
			return `transform:rotate(${this.resource_icon_rotation}deg)`
		},
		item_alignments_wrap: {
			get() {
				return this.$store.state.lst.resource_set_item_alignments_wrap
			},
			set(val) {
				this.$store.commit('lst_set', ['resource_set_item_alignments_wrap', val])
			}
		},
		// item_suggestions_wrap: {
		// 	get() { return this.$store.state.lst.resource_set_item_suggestions_wrap },
		// 	set(val) { this.$store.commit('lst_set', ['resource_set_item_suggestions_wrap', val]) }
		// },
		description_expanded: {
			get() {
				return this.$store.state.lst.resource_view_description_expanded
			},
			set(val) {
				this.$store.commit('lst_set', ['resource_view_description_expanded', val])
			}
		},
		full_content_expanded: {
			get() {
				return this.$store.state.lst.resource_view_full_content_expanded
			},
			set(val) {
				this.$store.commit('lst_set', ['resource_view_full_content_expanded', val])
			}
		},
		description_expandable() {
			if (empty(this.current_resource.description)) return false
			let jq = $('.k-resource-view-description')
			return jq.length > 0 && jq[0].scrollHeight > 70
		},
		full_content_expandable() {
			if (empty(this.current_resource.full_content)) return false
			let jq = $('.k-resource-view-full_content')
			return jq.length > 0 && jq[0].scrollHeight > 70
		},
		editing_resource() {
			return !empty(this.resource_for_editing)
		},
		edited_resource_changed() {
			if (!this.editing_resource) return false
			return (
				JSON.stringify(this.current_resource.copy_for_save()) !=
        JSON.stringify(this.resource_for_editing.copy_for_save())
			)
		},
		grade_low: {
			get() {
				let resource = this.editing_resource ? this.resource_for_editing : this.current_resource
				if (!resource || resource.educationLevel.length == 0) return ''
				let el = resource.educationLevel[0]
				let grade = this.grades.find(g => {
					return g.value == el || (!isNaN(el * 1) && g.value * 1 == el * 1)
				})
				if (!empty(grade)) return grade
				return ''
			},
			set(new_el) {
				// get grade index of new lower-limit education level
				let new_el_index = this.grades.findIndex(g => {
					return g.value == new_el || (!isNaN(new_el * 1) && g.value * 1 == new_el * 1)
				})

				// get grade index of current upper-limit education level
				let el_high = this.resource_for_editing.educationLevel[this.resource_for_editing.educationLevel.length - 1]
				let el_high_index = this.grades.findIndex(g => {
					return g.value == el_high || (!isNaN(el_high * 1) && g.value * 1 == el_high * 1)
				})

				// if el_high_index is < new_el_index,
				if (el_high_index < new_el_index) {
					// if 9th grade was chosen, default to 12, because most HS courses are 9-12
					if (new_el == '09') el_high_index = this.grades.findIndex(g => g.value == '12')
					// else just include new_el_index
					else el_high_index = new_el_index
				}

				// include all grades between new_el and el_high
				let arr = []
				for (let i = new_el_index; i <= el_high_index; ++i) {
					if (!empty(this.grades[i].value)) arr.push(this.grades[i].value)
				}
				this.resource_for_editing.educationLevel = arr
			}
		},
		grade_high: {
			get() {
				let resource = this.editing_resource ? this.resource_for_editing : this.current_resource
				if (!resource || resource.educationLevel.length == 0) return ''
				let el = resource.educationLevel[resource.educationLevel.length - 1]
				let grade = this.grades.find(g => {
					return g.value == el || (!isNaN(el * 1) && g.value * 1 == el * 1)
				})
				if (!empty(grade)) return grade
				return ''
			},
			set(new_el) {
				// get grade index of new upper-limit education level
				let new_el_index = this.grades.findIndex(g => {
					return g.value == new_el || (!isNaN(new_el * 1) && g.value * 1 == new_el * 1)
				})

				// get grade index of current lower-limit education level
				let el_low = this.resource_for_editing.educationLevel[0]
				let el_low_index = this.grades.findIndex(g => {
					return g.value == el_low || (!isNaN(el_low * 1) && g.value * 1 == el_low * 1)
				})

				// if el_low_index is > new_el_index, just include new_el_index
				if (el_low_index > new_el_index) el_low_index = new_el_index

				// include all grades between new_el and el_high
				let arr = []
				for (let i = el_low_index; i <= new_el_index; ++i) {
					if (!empty(this.grades[i].value)) arr.push(this.grades[i].value)
				}
				this.resource_for_editing.educationLevel = arr
			}
		},
		current_resource_search_terms_wrapper: {
			get() {
				return this.current_resource_search_terms
			},
			set(val) {
				this.current_resource_search_terms = val
				// establish the debounce fn if necessary
				if (empty(this.save_current_resource_search_terms_debounced)) {
					this.save_current_resource_search_terms_debounced = U.debounce(() => {
						// console.log('debouncer: ' + this.current_resource_search_terms)
						this.$store.commit('set', [this.current_resource, 'search_terms', this.current_resource_search_terms])

						// if the user tapped the enter key, clear the flag
						if (this.prevent_current_resource_search_terms_debounce) {
							this.prevent_current_resource_search_terms_debounce = false

							// otherwise if have a tba_framework_identifier, update suggestions
						} else if (this.tba_framework_identifier) {
							// if the user just entered terms, make sure the search_terms flag is on
							if (!empty(this.current_resource_search_terms)) {
								this.comp_factors.search_terms = true
								// and if item_assoc_weight_pct is 0, let the user know
								if (this.comp_factor_weights.item == 0) {
									this.$inform(
										'Note that the Resource metadata evidence weighting value is currently set to 0, so Search Terms are not being factored into suggestion scores.'
									)
								}
							}
							this.make_suggestions()
						}
					}, 1000)
				}
				// call the debounce fn
				this.save_current_resource_search_terms_debounced()
			}
		},

		alignments_to_show() {
			let add_fr = framework_identifier => {
				let framework_record = this.framework_records.find(x => x.lsdoc_identifier == framework_identifier)
				if (!framework_record) {
					// shouldn't happen
					console.error('Couldn’t find framework_record for framework_identifier ' + framework_identifier)
					return false
				}
				let f = {
					framework_record: framework_record,
					cfdocument: framework_record.json.CFDocument,
					alignments: []
				}
				// if framework isn't fully loaded AND THIS IS THE BASE FRAMEWORK, load it now
				// we don't currently load all frameworks because this takes a very long time if your resources are aligned to a lot of frameworks
				if (!framework_record.framework_json_loaded && !framework_record.framework_json_loading) {
					if (framework_record.lsdoc_identifier == this.base_framework_identifier) {
						U.load_framework_and_cfo(framework_record.lsdoc_identifier)
					} else {
						// console.warn('skipping loading for framework: ' + framework_record.json.CFDocument.title)
					}
				}
				return f
			}

			let arr = []

			// side effect: determine no_alignments_to_base_framework. for starters assume this is TRUE if we HAVE a base framework
			this.no_alignments_to_base_framework = !empty(this.base_framework_identifier)

			for (let a of this.current_resource.alignments) {
				let f = arr.find(x => x.cfdocument.identifier == a.framework_identifier)
				if (!f) {
					f = add_fr(a.framework_identifier)
					if (a.framework_identifier == this.tba_framework_identifier) {
						// if we're currently aligning, make sure that framework appears first
						arr.unshift(f)
					} else {
						arr.push(f)
					}
				}

				// PW: at some point I had this here, but if we do this we don't list the # of alignments for each framework when we have a base framework
				// if (empty(f.framework_record.cfo)) {
				// 	continue
				// }

				// if we find an alignment to the base framework, no_alignments_to_base_framework is FALSE
				if (a.framework_identifier == this.base_framework_identifier) {
					this.no_alignments_to_base_framework = false
				}

				let o = {}
				o.alignment = a
				o.key = `${a.framework_identifier}-${a.item_identifier}`

				// skip duplicates
				if (f.alignments.find(x => x.key == o.key)) {
					console.log('skipping duplicate alignment')
					continue
				}

				// set default statement and tree_key, then try to get actual statement and tree_key from framework_record if it's loaded
				// (note that if it's not loaded initially, it should be loaded momentarily)
				o.statement = `${a.framework_identifier} / ${a.item_identifier}`
				o.tree_key = 1000000
				if (f.framework_record.cfo && f.framework_record.cfo.cfitems) {
					let cfitem = f.framework_record.cfo?.cfitems[a.item_identifier]
					if (cfitem) {
						o.hcs = cfitem.humanCodingScheme
						o.statement = U.marked_latex(cfitem.fullStatement)
						// if (cfitem.humanCodingScheme) o.statement += `<b class="mr-2">${cfitem.humanCodingScheme}</b> `
						// o.statement +=
						o.tree_key = cfitem.tree_nodes[0]?.tree_key ?? 1000000
					}
				}
				f.alignments.push(o)
			}

			// sort each framework's alignments by tree_key
			for (let o of arr) {
				o.alignments.sort((a, b) => {
					return a.tree_key - b.tree_key
				})
			}

			// sort so that the base framework is on top
			if (!empty(this.base_framework_identifier)) {
				arr.sort((a, b) => {
					if (a.framework_record.lsdoc_identifier == this.base_framework_identifier) return -1
					if (b.framework_record.lsdoc_identifier == this.base_framework_identifier) return 1
					return 0
				})
			}
			return arr
		},

		// return true iff we have comp factors available for this resource -- i.e. if we can make suggestions
		comp_factors_available() {
			if (this.comp_factor_weights.item > 0) {
				if (this.comp_factors.title && this.current_resource.resource_title) return true
				if (this.comp_factors.description && this.current_resource.description) return true
				if (this.comp_factors.full_content && this.current_resource.full_content) return true
				if (this.comp_factors.text && this.current_resource.text) return true
				if (this.comp_factors.search_terms && this.current_resource.search_terms) return true
			}
			if (this.comp_factor_weights.assocs > 0) {
				if (
					(this.comp_factors.sme_assocs || this.comp_factors.ai_assocs) &&
          this.current_resource.alignments.length > 0
				)
					return true
			}
			return false
		},

		limiters() {
			return this.set_component.limiters
		},
		// whether or not to "normalize" the "bars" that show match scores
		normalize_match_score_bars: {
			get() {
				return this.$store.state.lst.resource_normalize_match_score_bars
			},
			set(val) {
				this.$store.commit('lst_set', ['resource_normalize_match_score_bars', val])
			}
		},
		// when limiting to a branch, whether to show the children of the branch, or alignable items in the branch
		children_or_alignable: {
			get() {
				return this.$store.state.lst.resource_children_or_alignable
			},
			set(val) {
				this.$store.commit('lst_set', ['resource_children_or_alignable', val])
				// recalculate suggestions when this changes
				this.make_suggestions()
			}
		},
		suggestions_updated_showing() {
			return this.set_component.suggestions_updated_showing
		},
		suggestion_computing() {
			return this.set_component.suggestion_computing
		},
		comp_factors() {
			return this.set_component.comp_factors
		},
		comp_factor_weights() {
			return this.set_component.comp_factor_weights
		},
		item_assoc_weight_pct: {
			// this will be the percentage to weight item metadata in relation to assoc metadata
			// technically, the value will go from 0-12, and we'll scale from there
			get() {
				return this.$store.state.lst.resource_set_item_assoc_weight_pct
			},
			set(val) {
				this.$store.commit('lst_set', ['resource_set_item_assoc_weight_pct', val])
			}
		},
		base_framework_identifier: {
			get() {
				let fi = this.$store.state.lst.align_base_framework_identifier[this.tba_framework_identifier] ?? ''
				if (!this.framework_records.find(x => x.lsdoc_identifier == fi)) return ''
				return fi
			},
			set(val) {
				this.$store.commit('lst_set_hash', ['align_base_framework_identifier', this.tba_framework_identifier, val])
			}
		},
		base_framework_record() {
			return this.set_component.base_framework_record
		},
		suggestion_factors_string() {
			return this.set_component.suggestion_factors_string
		},
		auto_starting_alignment: {
			get() {
				return this.$store.state.lst.resource_set_auto_starting_alignment
			},
			set(val) {
				this.$store.commit('lst_set', ['resource_set_auto_starting_alignment', val])
			}
		},
		// 'to-be-aligned' framework_identifier
		tba_framework_identifier: {
			get() {
				return this.set_component.tba_framework_identifier
			},
			set(val) {
				return (this.set_component.tba_framework_identifier = val)
			}
		},
		tba_framework_record() {
			return this.set_component.tba_framework_record
		},
		tba_framework_record_descriptor() {
			return this.set_component.tba_framework_record_descriptor
		},

		nomatch_assoc() {
			if (empty(this.tba_framework_identifier)) return null

			// we're not supporting the "nomatch" functionality in the old-style alignment system that Star Autism is using
			if (!this.is_case_resource_set) return null

			return this.resource_set.framework_record.json.CFAssociations.find(x=>
				x.associationType == 'ext:hasNoMatch'
				&& x.originNodeURI.identifier == this.current_resource.cfitem.identifier
				&& x.destinationNodeURI.identifier == this.tba_framework_identifier
			)
		},
	},
	watch: {
		current_resource: {
			immediate: true,
			handler() {
				this.current_resource_search_terms = this.current_resource.search_terms
				this.candidates_showing_on_right = []
				if (this.resource_id == 1) {
					this.edit_resource_start()
				} else if (this.tba_framework_identifier) {
					if (this.resource_suggestion_dirty(this.current_resource)) {
						this.make_suggestions()
					}
					this.auto_start_alignment()
				}
				this.resource_icon = this.current_resource.random_icon()
				// this.resource_icon_rotation = this.current_resource.random_icon_rotation()
				// console.warn('resetting base_item_for_alignment')
				// this.base_item_for_alignment = ''
			}
		},

		suggestion_factors_string() {
			// console.warn('suggestion_factors_string changed')
			if (this.tba_framework_identifier) {
				this.make_suggestions()
				this.auto_start_alignment()
			}
		}
	},
	created() {
		if (empty(this.current_resource)) {
			this.$emit('show_table', 'confirmed')
			return
		}

		vapp.resource_viewer_component = this
	},
	mounted() {},
	methods: {
		report_ms(str) {
			return this.set_component.report_ms(str)
		},
		comp_factors_changed(param, val) {
			return this.set_component.comp_factors_changed(param, val)
		},
		resource_suggestion_dirty(resource) {
			return this.set_component.resource_suggestion_dirty(resource)
		},
		set_candidates_showing(resource, n_to_add) {
			return this.set_component.set_candidates_showing(resource, n_to_add)
		},
		make_alignments(resource, aligned_items) {
			return this.set_component.make_alignments(resource, aligned_items)
		},
		clear_alignments(resource, items_to_clear) {
			return this.set_component.clear_alignments(resource, items_to_clear)
		},

		candidate_color(candidate) {
			if (candidate.is_ancestor) return 'amber darken-4'

			if (candidate.currently_aligned) return 'green darken-3'
			let r = this.batch_alignments_to_create.find(x => x.resource_id == this.resource_id)
			if (r) {
				if (r.alignments.find(x => x.ii == candidate.cfitem.identifier)) return 'pink darken-3'
			}
			// if (this.batch_alignments_to_create.find(x=>x.resource_id==this.resource_id)) return 'pink darken-3'
			return 'grey darken-4'
		},

		candidate_outer_class(candidate) {
			let s = ''
			// apply nowrap class if needed
			if (!this.item_alignments_wrap) s += ' k-resource-view-current-alignment-nowrap'

			// and apply class indicating the user has clicked it if needed
			if (this.candidates_showing_on_right.includes(candidate.cfitem.identifier)) {
				s += ' k-resource-view-candidate-clicked'
			}

			if (!empty(candidate.parent_candidate)) {
				// s += ' ml-8'
				s += ' k-resource-view-candidate-descendent'
			}

			if (candidate.is_ancestor) {
				s += ' k-resource-view-candidate-ancestor'
			}

			if (!candidate.is_alignable) {
				s += ' k-resource-view-candidate-not-alignable'
			}

			// if (candidate.simscore == 0) {
			// 	s += ' k-resource-view-candidate-zero-simscore'
			// }

			return s
		},

		edit_resource_start() {
			// console.warn('hide: edit_resource_start')
			vapp.$refs.satchel.execute('hide')
			this.resource_for_editing = new Resource(this.current_resource)
			this.resource_icon = this.resource_for_editing.random_icon()
			// this.resource_icon_rotation = this.resource_for_editing.random_icon_rotation()
		},

		edit_resource_cancel(flag) {
			if (flag !== 'confirmed' && this.edited_resource_changed) {
				// stash original flag in case we re-call this fn
				this.original_edit_resource_cancel_flag = flag

				let msg
				if (this.is_new_resource)
					msg = `You appear to have started making edits to this new resource record. 	Are you sure you want to cancel and discard your edits?`
				else
					msg = `You appear to have made edits to this resource record. Are you sure you want to cancel and discard your edits?`
				this.$confirm({
					title: 'Are you sure?',
					text: msg,
					acceptText: 'Discard Edits',
					cancelText: 'Keep Editing'
				})
					.then(y => {
						if (this.is_new_resource) {
							this.$emit('show_table', 'confirmed')
						} else {
							this.edit_resource_cancel('confirmed')
						}
					})
					.catch(n => {
						console.log(n)
					})
					.finally(f => {})
				return
			}

			// the user clicked in ResourceSet to show the table, or this was a new resource, emit show_table here
			if (this.is_new_resource || this.original_edit_resource_cancel_flag == 'show_table') {
				this.original_edit_resource_cancel_flag = ''
				this.$emit('show_table', 'confirmed')
			}
			this.original_edit_resource_cancel_flag = ''

			this.resource_icon = this.current_resource.random_icon()
			// this.resource_icon_rotation = this.current_resource.random_icon_rotation()

			// otherwise cancel editing
			this.resource_for_editing = null
		},

		edit_resource_save(flag) {
			// if the set is represented by a CASE framework...
			if (this.is_case_resource_set) {
				// this is modeled on the code in ItemEditor
				let fr = this.current_resource.framework_record

				// get the cfitem for this resource, with edits made by the user
				let cfitem = this.resource_for_editing.cfitem_for_save()

				// set lastChangeDateTime to *NOW* so we'll update it
				cfitem.lastChangeDateTime = '*NOW*'

				let data = {
					update_item_types: false,
					lsdoc_identifier: fr.lsdoc_identifier,
					CFItems: [cfitem],
					CFAssociations: [],
					check_out_and_in: 'yes', // require check_out_and_in; this saves an archive and prevents this from being done if someone else is editing the framework
					show_spinner: false
				}

				// if this is a new resource, we need to create an isChildOf assoc for the item; tie it to the document
				if (this.is_new_resource) {
					// in this case we will also need to set up the cfitem's identifier and uri (we set lastChangeDateTime above)
					cfitem.identifier = this.current_resource.cfitem.identifier
					cfitem.uri = U.generate_child_uri(fr.json.CFDocument, cfitem.identifier, 'CFItems')

					// also set the itemType, and tell the service to update_item_types
					cfitem.CFItemType = 'Learning Resource'
					data.update_item_types = true

					let sequence
					if (fr.cfo.cftree.children.length == 0) sequence = 1
					else {
						sequence = fr.cfo.cftree.children[fr.cfo.cftree.children.length - 1].sequence
						if (empty(sequence)) sequence = 1
						else sequence = sequence + 1
					}
					let child_association = U.create_association(fr.json.CFDocument, cfitem, sequence, fr.json.CFDocument)
					data.CFAssociations.push(child_association.to_json())
				}

				this.$store.dispatch('save_framework_data', data).then(() => {
					// create or update the CFItem(s) in the framework json
					for (let cfi of data.CFItems) {
						let index = fr.json.CFItems.findIndex(x => x.identifier == cfi.identifier)

						cfi.lastChangeDateTime = this.$store.state.framework_lastChangeDateTime

						// get a new clean json object
						let clean_json = new CFItem(cfi).to_json()

						if (index == -1) {
							this.$store.commit('set', [fr.json.CFItems, 'PUSH', clean_json])

							// add to cfo
							U.add_child_to_cfo(clean_json, fr.cfo.cftree, this.$store, fr.cfo)
						} else {
							this.$store.commit('set', [fr.json.CFItems, 'SPLICE', index, clean_json])

							// transfer updates to the cfo cfitem; there are relatively few properties we deal with here, since most stuff is in extensions
							let cfo_cfitem = fr.cfo.cfitems[cfi.identifier]
							this.$store.commit('set', [cfo_cfitem, 'fullStatement', cfi.fullStatement])
							this.$store.commit('set', [cfo_cfitem, 'lastChangeDateTime', cfi.lastChangeDateTime])
							this.$store.commit('set', [cfo_cfitem, 'educationLevel', object_copy(cfi.educationLevel)])
							this.$store.commit('set', [cfo_cfitem, 'extensions', object_copy(cfi.extensions)])
						}
					}

					// we may have saved isChildOf assocs
					for (let assoc of data.CFAssociations) {
						// use server date/time for all timestamps
						if (assoc.lastChangeDateTime == '*NOW*') {
							assoc.lastChangeDateTime = this.$store.state.framework_lastChangeDateTime
						}

						// add to or update in the CFAssociations
						let index = fr.json.CFAssociations.findIndex(x => x.identifier == assoc.identifier)
						if (index == -1) {
							this.$store.commit('set', [fr.json.CFAssociations, 'PUSH', assoc])
						} else {
							this.$store.commit('set', [fr.json.CFAssociations, 'SPLICE', index, assoc])
						}
					}
					/////////////////////////
					// above dealt with the cfitem and the framework; now deal with the resource

					this.resource_for_editing = null

					let updated_cfitem = fr.json.CFItems.find(x => x.identifier == data.CFItems[0].identifier)

					// if we just created and saved a new resource...
					if (this.is_new_resource) {
						// new_resource_created in ResourceSet will create a proper resource record for the new resource
						this.$emit('new_resource_created', {
							cfitem: updated_cfitem,
							framework_record: fr
						})
						return
					}

					// else update properties of the edited resource, then stop editing
					// TODO: note that we're not using commit.set here; hopefully that's OK
					this.current_resource.update_from_cfitem(updated_cfitem)
					this.current_resource.cfitem = updated_cfitem

					// set the resource_title_index for the updated resource, then make sure we're sorted properly
					this.set_component.set_resource_title_indices()
					this.set_component.sort_table_filtered_resources()

					if (this.tba_framework_identifier && this.resource_suggestion_dirty(this.current_resource)) {
						this.make_suggestions()
					}
				})

				// else save to resource db tables
			} else {
				let resource_to_save
				// we're in editing mode; if nothing changed, return
				if (!this.edited_resource_changed) return

				// else show the loading indicator, and clear alignments from resource_for_editing before save
				U.loading_start()
				resource_to_save = this.resource_for_editing.copy_for_save()

				let payload = {
					service_url: 'save_resources',
					// we stringify the resources in case it's a lot of data
					resources: JSON.stringify([resource_to_save]),
					user_id: this.user_info.user_id,
					return_resources: 'yes',
					return_resource_alignments: 'no', // we're not updating alignments here
					return_raw_alignments: 'no'
				}
				this.$store
					.dispatch('service', payload)
					.then(result => {
						U.loading_stop()
						let resource_data = result.resources[0]
						this.resource_for_editing = null

						// if we just created and saved a new resource...
						if (this.is_new_resource) {
							this.$emit('new_resource_created', resource_data)
							return
						}

						// else update properties of the edited resource, then stop editing
						for (let key in resource_data) {
							this.$store.commit('set', [this.current_resource, key, resource_data[key]])
						}

						// set the resource_title_index for the updated resource, then make sure we're sorted properly
						this.set_component.set_resource_title_indices()
						this.set_component.sort_table_filtered_resources()

						if (this.tba_framework_identifier && this.resource_suggestion_dirty(this.current_resource)) {
							this.make_suggestions()
						}
					})
					.catch(result => {
						console.warn(result)
						U.loading_stop()
						this.$alert('<b class="red--text">An error occurred:</b> ' + (result.error ? result.error : result.status))
					})
					.finally(() => {})
			}
		},

		async edit_resource_remove() {
			if (!this.set_component.user_can_remove) {
				this.$alert(
					'Only the creator of a resource, or the creator of the resource’s resource set, can remove a resource.'
				)
				return
			}

			try {
				await this.$confirm({
					title: 'Are you sure?',
					text: 'Are you sure you want to remove this resource?',
					acceptText: 'Remove',
					acceptColor: 'red darken-3'
				})
			} catch (e) {
				return
			}

			// OG way to remove
			if (!this.is_case_resource_set) {
				let payload = {
					service_url: 'remove_resources',
					resource_ids: [this.current_resource.resource_id],
					user_id: this.user_info.user_id
				}
				this.$store
					.dispatch('service', payload)
					.then(result => {
						this.$emit('resource_removed', this.current_resource.resource_id)
					})
					.catch(result => {
						this.$alert('<b class="red--text">An error occurred:</b> ' + (result.error ? result.error : result.status))
					})
					.finally(() => {})

				// CASE way to remove
			} else {
				let node = this.resource_set.framework_record.cfo.cfitems[this.current_resource.resource_id]?.tree_nodes[0]
				if (!node) console.warn('couldn’t get node to delete')
				else {
					// use delete_framework_items to delete the cfitem
					let payload = {
						framework_record: this.resource_set.framework_record,
						nodes_to_delete: [node]
					}
					await this.$store.dispatch('delete_framework_items', payload)

					// emitted event will remove the resource
					this.$emit('resource_removed', this.current_resource.resource_id)
				}
			}
		},

		toggle_choose_lowest_ancestor() {},

		cancel_lowest_ancestor() {},

		current_resource_search_terms_keydown($evt) {
			// if user taps enter key, immediately make suggestions
			if ($evt.key === 'Enter') {
				this.current_resource_search_terms = $.trim(this.current_resource_search_terms)
				this.make_suggestions()
				$evt.preventDefault()

				// set a flag so we don't make suggestions again when the current_resource_search_terms debounce fn runs
				this.prevent_current_resource_search_terms_debounce = true
			}
		},

		spin_resource_icon(direction) {
			if (typeof direction != 'number') direction = 1
			this.resource_icon_rotation += direction * 360
		},

		generate_random_resource_id() {
			if (empty(this.resource_for_editing.external_resource_id)) {
				this.resource_for_editing.external_resource_id = U.new_uuid()
			}
		},

		show_alignment(alignment) {
			// if we're currently aligning and this alignment is to the tba_framework, use start_alignment instead
			if (this.tba_framework_identifier && alignment.framework_identifier == this.tba_framework_identifier) {
				this.start_alignment(alignment)
				return
			}

			let data = {
				framework_identifier: alignment.framework_identifier,
				item_identifier: alignment.item_identifier,
				allow_framework_switching: false // don't allow framework switching here
			}
			let selected_items = []
			// send through any other items from this framework that are already aligned to this resource
			for (let alignment of this.current_resource.alignments) {
				if (alignment.framework_identifier == data.framework_identifier) selected_items.push(alignment.item_identifier)
			}
			if (selected_items.length > 0) data.selected_items = selected_items

			let show_data = {
				// fn called when a new framework is chosen by the user (also called as soon as the iframe loads)
				// framework_chosen_callback_fn: (framework_identifier)=> {
				// },

				// fn called when embedded satchel is hidden
				embed_hide_callback_fn: arg => {
					// // console.warn('embed_hide_callback_fn', arg)
					// if the user explicitly closed the chooser and we're in aligning mode, restart the alignment process
					if (arg == 'control-btn') {
						// ??? I don't think we actually want to do this...
						// if (this.tba_framework_identifier) this.$nextTick(x=>this.start_alignment())
					}
				},

				// fn called continuously while embedded satchel is open; if it returns true, embedded satchel will be closed
				hide_fn: () => {
					// if ($('.k-resource-view').is(':visible') == false) console.warn('hide: hide_fn (show_alignment)')
					return $('.k-resource-view').is(':visible') == false
				},

				small_frame_top: 60,
				small_frame_width: this.satchel_embed_width
			}
			// console.warn('show: show_alignment')
			vapp.$refs.satchel.execute('show', show_data).then(() => {
				vapp.$refs.satchel.execute('load_framework', data).then(() => {
					vapp.$refs.satchel.execute('chooser', { chooser_mode: false })
				})
			})
		},

		auto_start_alignment() {
			if (this.auto_starting_alignment) {
				let params = { reset: true }
				// if we have a last_clicked_tba_limiter,
				if (!empty(this.last_clicked_tba_limiter)) {
					params.item_identifier = this.last_clicked_tba_limiter.identifier
					this.make_suggestions()
				} else if (this.limiters.include_branches?.length == 1) {
					params.item_identifier = this.limiters.include_branches[0]
					this.make_suggestions()
				}
				this.start_alignment(params)
			}
		},

		start_alignment(params) {
			// console.warn('start_alignment', params)
			if (empty(params)) params = {}
			let data = {
				allow_framework_switching: false // don't allow framework switching here
			}

			// unless told to do so, don't reset what is currently showing
			if (params.reset) {
				data.force_framework_reset = true
			} else {
				data.no_framework_reset = true
			}

			// we are usually showing the tba_framework_identifier here
			if (params.framework_identifier) data.framework_identifier = params.framework_identifier
			else data.framework_identifier = this.tba_framework_identifier
			// data.framework_identifier = 'b87078f4-a87c-4fb2-9598-ad0c567d9615'	// TN sci test

			// array of cfitems that are currently aligned to the resource
			let selected_items = []
			if (params.selected_items) data.selected_items = params.selected_items
			else if (data.framework_identifier) {
				// send through any items from this framework that are already aligned to this resource
				for (let alignment of this.current_resource.alignments) {
					if (alignment.framework_identifier == data.framework_identifier)
						selected_items.push(alignment.item_identifier)
				}
				if (selected_items.length > 0) data.selected_items = selected_items
			}

			// array of candidate items that have been clicked by the user; leave at null if we don't have any
			if (this.candidates_showing_on_right.length > 0) {
				data.candidate_items = this.candidates_showing_on_right
			}

			// if we received an item_identifier, highlight and scroll to that item
			if (params.item_identifier) {
				data.item_identifier = params.item_identifier
				data.scroll_to_item_identifier = true
			}

			let show_data = {
				// fn called when a new framework is chosen by the user (also called as soon as the iframe loads)
				framework_chosen_callback_fn: framework_identifier => {
					this.tba_framework_identifier = framework_identifier
				},

				// fn called when embedded satchel is hidden
				embed_hide_callback_fn: arg => {
					// console.warn('embed_hide_callback_fn', arg)
					// if the user explicitly closed the chooser, set auto_starting_alignment to false (if the chooser is autmatically closed via hide_fn (below), this won't happen)
					if (arg == 'control-btn') this.auto_starting_alignment = false
				},

				// fn called continuously while embedded satchel is open; if it returns true, embedded satchel will be closed
				hide_fn: () => {
					// if ($('.k-resource-view').is(':visible') == false) console.warn('hide: hide_fn (start_alignment)')
					return $('.k-resource-view').is(':visible') == false
				},

				small_frame_top: 60,
				small_frame_width: this.satchel_embed_width
			}

			// once user has clicked to start_alignment, assume they want to auto_start future alignments, until/unless they explicitly click to close the chooser
			this.auto_starting_alignment = true

			// when an item is *clicked* in the tree (not selected)
			let item_clicked_callback_fn = clicked_item_data => {
				// limit suggestions to the clicked item
				let cfitem = clicked_item_data.cfitem
				// if (cfitem.identifier == this.tba_framework_identifier || cfitem.identifier == this.last_clicked_tba_limiter?.identifier) {
				if (cfitem.identifier == this.last_clicked_tba_limiter?.identifier) {
					this.last_clicked_tba_limiter = null
				} else {
					this.last_clicked_tba_limiter = cfitem
				}
				this.make_suggestions()
			}

			// console.warn('show: start_alignment')
			vapp.$refs.satchel.execute('show', show_data).then(() => {
				vapp.$refs.satchel.execute('load_framework', data).then(() => {
					this.report_ms('start_alignment: framework loaded')
					vapp.$refs.satchel
						.execute('chooser', { chooser_mode: true, item_clicked_callback_fn: item_clicked_callback_fn })
						.then(aligned_item => {
							// console.warn('aligned_item', aligned_item)
							let i = selected_items.findIndex(identifier => identifier == aligned_item.cfitem.identifier)
							if (i > -1) {
								// if user previously chose this item, remove it
								this.report_ms('clear_alignments start')
								this.clear_alignments(this.current_resource, [aligned_item]).then(() => {
									// spin the resource icon backwards, then re-start the alignment process with the first aligned_item's framework
									this.spin_resource_icon(-1)
									this.start_alignment({
										framework_identifier: data.framework_identifier
									})
								})
							} else {
								// else add it and when done...
								this.report_ms('make_alignments start')
								this.make_alignments(this.current_resource, [aligned_item]).then(() => {
									// spin the resource icon, then re-start the alignment process with the aligned_item's framework and identifier
									this.spin_resource_icon()
									this.start_alignment({
										framework_identifier: data.framework_identifier,
										lsitem_identifier: aligned_item.cfitem.identifier
									})
								})
							}
						})
				})
			})
		},

		async make_suggestions() {
			// if we have a last_clicked_tba_limiter, limit to that branch
			let params = {}
			if (!empty(this.last_clicked_tba_limiter)) {
				params.include_branches = [this.last_clicked_tba_limiter.identifier]
				// params.item_types = false
				params.item_types = 'children'
			}

			// if we're making suggestions based on cross-alignments, we currently need to have a single base framework specified
			if (!this.set_component.check_for_base_framework_required()) {
				// if check_for_base_framework_required fails, the user will see an alert; show the settings so the user can choose a base framework
				this.set_component.settings_showing = true
				return
			}

			this.set_component.get_resource_alignment_suggestions(this.current_resource, params)
			this.set_component.compute_all_suggestions_clean()

			// // this rigamarole would get the loading indicator to show while we're making suggestions
			// currently we're not showing the loader; we just show a small div that says "computing suggestions"
			// BUT if a framework has to load, THAT will show the loader
			// U.loading_start('Computing suggestions…')
			// setTimeout(async x=>{
			// 	await this.set_component.get_resource_alignment_suggestions(this.current_resource)
			// 	U.loading_stop()
			// })
		},

		candidate_clicked(candidate) {
			// if this candidate is one of the types we're aligning to, or if no types are specified,
			if (
				this.limiters.item_types.length == 0 ||
        this.limiters.item_types.includes(U.item_type_string(candidate.cfitem))
			) {
				let data = {
					framework_identifier: candidate.framework_identifier
				}
				// if this candidate wasn't already clicked, add it to candidates_showing_on_right; otherwise remove it
				let index = this.candidates_showing_on_right.findIndex(x => x == candidate.cfitem.identifier)
				if (index == -1) {
					this.candidates_showing_on_right.push(candidate.cfitem.identifier)
					// if it wasn't already clicked, we highlight and jump to the item
					data.item_identifier = candidate.cfitem.identifier
				} else {
					this.candidates_showing_on_right.splice(index, 1)
				}

				// call start_alignment either way, to reflect the updated candidates
				this.start_alignment(data)
			}

			// if the item has children, simulate what would happen if the user clicked the item in the tree -- limit to children of this item
			if (candidate.cfitem.tree_nodes[0]?.children?.length > 0) {
				if (candidate.cfitem.identifier == this.last_clicked_tba_limiter?.identifier) {
					this.last_clicked_tba_limiter = null
				} else {
					this.last_clicked_tba_limiter = candidate.cfitem
				}
				this.make_suggestions()
				// this.candidates_showing_on_right = []
				let data = {
					item_identifier: candidate.cfitem.identifier
				}
				this.start_alignment(data)
			}
		},

		candidate_alignment_changed(candidate) {
			if (candidate.currently_aligned) {
				this.make_alignments(this.current_resource, [candidate]).then(() => {
					if (this.tba_framework_identifier) {
						// spin the resource icon, then re-start the alignment process with the aligned_item's framework and identifier
						this.spin_resource_icon()
						this.start_alignment({
							framework_identifier: candidate.framework_identifier,
							lsitem_identifier: candidate.cfitem.identifier
						})
					}
				})
			} else {
				this.clear_alignments(this.current_resource, [candidate]).then(() => {
					if (this.tba_framework_identifier) {
						// spin the resource icon backwards, then re-start the alignment process with the first aligned_item's framework
						this.spin_resource_icon(-1)

						// also clear this item as a candidate
						let index = this.candidates_showing_on_right.findIndex(x => x == candidate.cfitem.identifier)
						if (index > -1) {
							this.candidates_showing_on_right.splice(index, 1)
						}

						this.start_alignment({
							framework_identifier: candidate.framework_identifier
						})
					}
				})
			}
		},

		// allow user to mark the item as having no match to the tba_framework
		// NOTE: we don't actually need to *do* anything with the hasNoMatch assocs; they are really just for informational purposes for the Rosetta user/operator.
		// See, e.g., resource_synch_to_cureum in ResourceSet 
		mark_as_no_match() {
			if (empty(this.tba_framework_identifier)) return

			// not allowed if there are current alignments
			let something_currently_aligned = this.current_resource.alignments.find(x=>x.framework_identifier == this.tba_framework_identifier)
			if (something_currently_aligned) {
				this.$alert('To mark the resource as “not aligned”, you must first delete the currently-specified alignments.')
				return
			}

			// add a hasNoMatch assoc to the tba_framework
 			let right_node_uri = {
				title: `NO MATCH: ${this.tba_framework_record.json.CFDocument.title}`,
				identifier: this.tba_framework_identifier,
				uri: this.tba_framework_record.json.CFDocument.uri,
				// add the assocationType here; make_alignments will deal with it
				associationType: 'ext:hasNoMatch'
			}
			// console.warn(right_node_uri)

			this.make_alignments(this.current_resource, [right_node_uri]).then(() => {
				// spin the resource icon
				this.spin_resource_icon()
			})
		},

		cancel_no_match() {
			if (empty(this.nomatch_assoc)) { // shouldn't happen
				console.error('ERROR: cancel_no_match called but we don’t have a nomatch_assoc')
				return
			}
			this.clear_alignments(this.current_resource, [this.nomatch_assoc])
		},
		
		choose_base_item_for_alignment(row) {
			// row.ao.alignment is the alignment to the base framework
			// row.ao.alignment.item_identifier is item_id from the base framework
			// what we want to do here is show the suggestions that are closest to that item from the base framework, ignoring everything else...
			if (this.base_item_for_alignment?.identifier == row.ao.alignment.item_identifier)
				this.base_item_for_alignment = null
			else
				this.base_item_for_alignment = {
					identifier: row.ao.alignment.item_identifier,
					ao: row.ao,
					item_text: row.tba_item_text
				}
			this.make_suggestions()
		},

		set_base_framework(framework_record) {
			if (this.set_component.base_framework_identifier == framework_record.lsdoc_identifier) {
				this.set_component.base_framework_identifier = ''
			} else {
				this.set_component.base_framework_identifier = framework_record.lsdoc_identifier
			}
			this.make_suggestions()
		},

		cancel_last_clicked_tba_limiter() {
			this.last_clicked_tba_limiter = null
			this.make_suggestions()
		},

		// user clicked button to move "up" one level
		tba_limiter_move_up() {
			if (!empty(this.last_clicked_tba_limiter)) {
				let cfi = this.tba_framework_record.cfo.cfitems[this.last_clicked_tba_limiter.identifier]
				if (cfi) {
					this.last_clicked_tba_limiter = cfi.tree_nodes[0].parent_node.cfitem
				}
			}
			this.make_suggestions()
			let data = {
				item_identifier: this.last_clicked_tba_limiter.identifier
			}
			this.start_alignment(data)
		},
	}
}
</script>

<style lang="scss">
.k-resource-view {
  padding: 16px 8px 12px 16px;
  margin: 0 auto;
  font-size: 16px;

  .k-case-ie-line-label {
    width: 110px;
    // align-self: flex-start;
    text-align: right;
    padding-right: 8px;
  }

  .k-resource-alignment-maker-resource-fields {
    .k-case-ie-line {
      font-size: 14px;
      margin-bottom: 4px;
      align-items: flex-start;
    }

    .k-case-ie-line-label {
      width: 112px;
      padding-top: 5px;
      text-align: left;
      flex-shrink: 0;
    }

    .k-case-ie-line-value {
      padding-top: 6px;
    }
  }
}

.k-resource-view-current-alignment {
  display: flex;
  align-items: flex-start;
  // margin-left:32px;
  font-size: 14px;
  line-height: 18px;
  padding: 4px 2px 3px 2px;
  border: 1px solid transparent;
  border-radius: 4px;
  margin-top: -1px;

  p {
    margin: 0;
  }
}

.k-resource-view-current-alignment-nowrap {
  white-space: nowrap;
}

.k-resource-view-candidate-clicked {
  // border:1px solid #000;
  background-color: $v-amber-lighten-5;
  border-color: $v-amber-darken-3;
}

.k-resource-view-candidate-zero-simscore {
  // not used
  opacity: 0.5;
}

.k-resource-view-candidate {
  padding-left: 4px;
  margin-left: -4px;
}

.k-resource-view-candidate-bar {
  width: 50px;
  .v-progress-linear {
    border-radius: 2px;
  }
}

.k-resource-view-candidate-ancestor {
  background-color: $v-amber-lighten-4;
  margin-top: 8px;
}

.k-resource-view-candidate-not-alignable {
  .k-resource-view-candidate-bar-outer {
    margin-top: 4px;
  }

  .k-resource-view-candidate-bar {
    width: 25px;
  }
}

.k-resource-view-candidate-descendent {
  // border-bottom: 1px solid #ccc;
  // margin-bottom:4px;
}

.k-resource-view-item-link p {
  margin: 0;
}

.k-resource-view-item-link:hover {
  text-decoration: underline;
  cursor: pointer;
}

.k-suggestion-computing-flasher {
  background-color: $v-orange-darken-3;
  color: #fff;
  // animation doesn't seem to work here...
  // animation: suggestion_computing_flasher .5s infinite;
}
// @keyframes suggestion_computing_flasher {
// 	0%, 100% {
// 		opacity: 0;
// 		visibility: hidden;
// 	}
// 	50% {
// 		opacity: 1;
// 		visibility: visible;
// 	}
// }

.k-resource-editor-description-textarea {
  textarea {
    max-height: 300px;
    overflow: auto;
  }
}

.k-resource-alignment-normalize-wrapper {
  .far,
  .fas {
    font-size: 18px;
  }

  .v-input--selection-controls__input {
    margin-right: 2px;
  }

  label {
    font-size: 13px !important;
  }

  .v-input--selection-controls__ripple {
    height: 24px;
    width: 24px;
    left: -7px;
    top: calc(50% - 19px);
  }
}
</style>
